import type { MentionRole } from "../../../services/visibilityService";

/**
 * Customer-facing wording shared by the AI Visibility dashboard and its
 * Business Profile findings, so one outcome never reads two ways on one page.
 */

/** Engine ids are internal; customers know the product names. */
export function engineLabel(id: string): string {
  const map: Record<string, string> = {
    openai: "ChatGPT",
    perplexity: "Perplexity",
    gemini: "Gemini",
    claude: "Claude",
    claude_memory: "Claude (from memory)",
  };
  // Own keys only: an id like "constructor" or "__proto__" must not resolve
  // to an Object.prototype member, which React cannot render.
  return Object.prototype.hasOwnProperty.call(map, id) ? map[id] : id;
}

/** Anything that is not a measured role (null, "unknown", a value added later)
 *  reads as "Could not be measured" — never as an absence. */
export function roleTitle(role: MentionRole | string | null | undefined): string {
  switch (role) {
    case "recommended": return "Recommended as a choice";
    case "mentioned": return "Named, but not recommended";
    case "cited_source_only": return "Used as a source, not named in the advice";
    case "absent": return "Not named at all";
    default: return "Could not be measured";
  }
}
